export const getInitials = (name) => {
  if (!name) return "?";
  // Separa por cualquier caracter no alfanumérico (espacios, puntos, guiones,
  // arrobas...) para que usuarios como "j.macchiavello" den "JM" y no "J.".
  const words = name.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  if (!words.length) return "?";
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return words[0].slice(0, 2).toUpperCase();
};
